import React from "react";
import { Button, CardContent, CardProps, Typography } from "@material-ui/core";
import { Subscription } from "../../../../../../../services/subscription/types/subscription";
import { getSubscription } from "../../../../sdk/subscriptions";
import { useParams } from "react-router";
import moment from "moment";
import { CardLoading } from "../../../../components/card-loading";
import { signIn } from "../../../../sdk/artists";

export const ArtistSummaryPlan: React.FC<CardProps> = (props) => {
  const { artistId } = useParams<{ artistId: string }>();

  const [subscription, setSubscription] = React.useState<Subscription>();
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    getSubscription(artistId)
      .then((sub) => setSubscription(sub))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [artistId]);

  const loginUser = () => {
    setLoading(true);
    signIn(artistId)
      .then((res) => {
        setLoading(false);
        window.open(res?.loginUrl);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <CardLoading {...props} loading={loading}>
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Plan
        </Typography>
        <Typography variant="h5" component="h2">
          {subscription?.plan}
        </Typography>
        {subscription?.isActive ? (
          subscription.ended_at ? (
            <Typography color="textSecondary">
              Ends: {moment(subscription.ended_at).format("LL")}
            </Typography>
          ) : (
            <Typography color="textSecondary">
              {subscription.started_at
                ? `Since: ${moment(subscription.started_at).format("LL")}`
                : "Active"}
            </Typography>
          )
        ) : (
          <Typography color="textSecondary">Cancelled</Typography>
        )}
        <Button
          style={{ marginTop: "10px" }}
          variant="contained"
          size="small"
          color="primary"
          onClick={() => loginUser()}
        >
          Login
        </Button>
      </CardContent>
    </CardLoading>
  );
};
